import data from "@sourceflow/useful_links.json";

export const useUsefulLinkTypes = () => {
  const field = data?.schema?.find((i) => i.name.toLowerCase() === "type");

  return field["dropdown_values"];
};

export default useUsefulLinkTypes;
